<template>
  <div>
    <slot v-bind="{ loading: loading, botinfo: botinfo }"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lineApi from '@/api/line'
export default {
  props: ['pageid'],
  data() {
    return {
      loading: true,
      botinfo: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.loading = true
    try {
      this.botinfo = await this.getBotInfo()
    } catch (error) {
      console.error(error)
    }
    this.loading = false
  },
  methods: {
    async getBotInfo() {
      let response = await lineApi.getLineInfo({
        params: {
          pageid: this.pageid
        }
      })
      if (response.status == 200 && response.data.data) {
        return response.data.data
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/LineProfile.vue